export default {
  common: {
    appName: 'Digital DVD Manager',
    loading: 'Cargando...',
    error: 'Error',
    success: 'Éxito',
    cancel: 'Cancelar',
    confirm: 'Confirmar',
    save: 'Guardar',
    delete: 'Eliminar',
    edit: 'Editar',
    create: 'Crear',
    back: 'Volver',
    close: 'Cerrar',
    search: 'Buscar',
    filter: 'Filtrar',
    actions: 'Acciones',
    yes: 'Sí',
    no: 'No',
    refresh: 'Actualizar',
    retry: 'Reintentar',
    info: 'Información importante',
  },
  auth: {
    loginTitle: "Iniciar Sesión",
    registerTitle: "Crear Cuenta de Fotógrafo",
    email: "Email",
    password: "Contraseña",
    confirmPassword: "Confirmar contraseña",
    fullName: "Nombre completo",
    firstName: "Nombre",
    lastName: "Apellidos",
    studioName: "Nombre del estudio",
    submitLogin: "Iniciar Sesión",
    submitRegister: "Crear Cuenta",
    logout: "Cerrar Sesión",
    rememberMe: "Recordarme",
    forgotPassword: "¿Olvidaste tu contraseña?",
    noAccount: "¿No tienes cuenta?",
    hasAccount: "¿Ya tienes cuenta?",
    registerHere: "Regístrate aquí",
    loginHere: "Inicia sesión aquí",
    loginDescription: "Accede a tu cuenta de EasyDigitalDVD",
    registerDescription: "Crea tu cuenta de fotógrafo y comienza a entregar tus proyectos de forma profesional",
    loggingIn: "Iniciando sesión...",
    registering: "Creando cuenta...",
    termsAccept: "Acepto los",
    termsAndConditions: "términos y condiciones",
    and: "y la",
    privacyPolicy: "política de privacidad",
    // Validaciones
    emailRequired: "El email es requerido",
    emailInvalid: "Email inválido",
    passwordRequired: "La contraseña es requerida",
    passwordMinLength: "La contraseña debe tener al menos 6 caracteres",
    passwordsNoMatch: "Las contraseñas no coinciden",
    confirmPasswordRequired: "Confirma tu contraseña",
    fullNameRequired: "El nombre es requerido",
    firstNameRequired: "El nombre es requerido",
    lastNameRequired: "Los apellidos son requeridos",
    studioNameRequired: "El nombre del estudio es requerido",
    // Errores
    loginError: "Error al iniciar sesión. Verifica tus credenciales.",
    registerError: "Error al crear cuenta. Intenta nuevamente.",
    emailExists: "Este email ya está registrado. Intenta iniciar sesión.",
    logoutError: "Error al cerrar sesión",
  },
  guards: {
    noAccess: "Acceso Denegado",
    noAccessDescription: "No tienes permisos para acceder a esta sección",
    backToApp: "Volver al Panel",
    needLogin: "Debes iniciar sesión para acceder",
  },
  navigation: {
    home: "Inicio",
    dashboard: "Dashboard",
    projects: "Proyectos",
    settings: "Configuración",
    profile: "Perfil",
    users: "Usuarios",
    overview: "Resumen",
  },
  buttons: {
    backToHome: "Volver al Inicio",
    viewDashboard: "Ver Dashboard",
    viewProjects: "Ver Proyectos",
  },
  // BLOQUE 4: Assets
  assets: {
    title: 'Archivos del proyecto',
    upload: 'Subir archivo',
    type: 'Tipo',
    label: 'Etiqueta',
    file: 'Archivo',
    selectType: 'Selecciona el tipo de archivo',
    selectFile: 'Selecciona un archivo',
    actions: {
      download: 'Descargar',
      delete: 'Eliminar',
    },
    confirmDeleteTitle: '¿Eliminar archivo?',
    confirmDeleteBody: 'Esta acción no se puede deshacer. El archivo se eliminará permanentemente.',
    empty: 'Aún no hay archivos',
    errors: {
      upload: 'Error al subir el archivo',
      delete: 'Error al eliminar el archivo',
      load: 'Error al cargar los archivos',
    },
    types: {
      cover: 'Portada',
      apk: 'APK (Android)',
      zip: 'ZIP',
      template: 'Plantilla',
      image: 'Imagen',
      other: 'Otro',
    },
  },
  public: {
    notFoundTitle: 'Proyecto no disponible',
    notFoundBody: 'El proyecto que buscas no está disponible. Verifica el código o contacta al fotógrafo.',
    downloadsTitle: 'Descargas',
    coverTitle: 'Portada',
    videosTitle: 'Videos',
    videosBody: 'Los videos se entregan en USB físico. Contacta con tu fotógrafo para coordinar la entrega.',
    backHome: 'Volver al inicio',
    noDownloads: 'No hay archivos disponibles para descargar',
    apkTitle: 'Aplicación Android',
    zipTitle: 'Archivos ZIP',
    templatesTitle: 'Plantillas',
    imagesTitle: 'Imágenes',
    otherTitle: 'Otros archivos',
    download: 'Descargar',
    providedBy: 'Proporcionado por',
    loading: 'Cargando proyecto...',
    errorLoading: 'Error al cargar el proyecto',
    externalLinksTitle: 'Links Adicionales',
    noExternalLinks: 'No hay links disponibles',
  },
  // BLOQUE 6: Delivery
  delivery: {
    title: 'Entrega',
    subtitle: 'Configura cómo se entregará el proyecto',
    usbIncluded: 'USB incluido',
    usbIncludedDesc: 'El proyecto incluye entrega física por USB',
    usbNotes: 'Notas del USB',
    usbNotesPlaceholder: 'Ej: USB 128GB, incluye videos en 4K y fotos en alta resolución',
    showExternal: 'Mostrar links externos en página pública',
    showExternalDesc: 'Los clientes podrán ver estos links en la página pública',
    externalLinks: 'Links externos',
    addLink: 'Agregar link',
    linkLabel: 'Título del link',
    linkUrl: 'URL',
    linkType: 'Tipo',
    linkTypeOther: 'Otro',
    noLinks: 'No hay links externos agregados',
    saveSuccess: 'Configuración guardada correctamente',
    errors: {
      load: 'Error al cargar configuración de entrega',
      save: 'Error al guardar configuración',
      invalidUrl: 'URL inválida (debe comenzar con https://)',
      labelRequired: 'El título es requerido',
      urlRequired: 'La URL es requerida',
    },
  },

  // =====================================================
  // BLOQUE 8: SUPERADMIN
  // =====================================================
  sa: {
    title: 'SuperAdmin',
    overview: {
      title: 'Resumen General',
      totalUsers: 'Total Usuarios',
      totalProjects: 'Total Proyectos',
      totalAssets: 'Total Archivos',
      usersByRole: 'Usuarios por Rol',
    },
    users: {
      title: 'Gestión de Usuarios',
      email: 'Email',
      name: 'Nombre',
      role: 'Rol',
      projects: 'Proyectos',
      createdAt: 'Fecha Registro',
      actions: 'Acciones',
      changeRole: 'Cambiar rol',
      confirmTitle: 'Confirmar cambio de rol',
      confirmBody: '¿Estás seguro de que deseas cambiar el rol de este usuario?',
      confirm: 'Confirmar',
      cancel: 'Cancelar',
      roleChanged: 'Rol actualizado correctamente',
      noUsers: 'No hay usuarios registrados',
      // BLOQUE 3/3: Crear usuario
      createUser: 'Crear usuario',
      inviteInfo: 'Se enviará un correo de invitación al usuario para que configure su contraseña.',
      sending: 'Enviando...',
      sendInvite: 'Enviar invitación',
    },
    audit: {
      title: 'Registro de Auditoría',
      actor: 'Usuario',
      action: 'Acción',
      entity: 'Entidad',
      details: 'Detalles',
      date: 'Fecha',
      noLogs: 'No hay registros de auditoría',
    },
    settings: {
      title: 'Configuración Global',
      comingSoon: 'Configuración global próximamente',
      description: 'Aquí podrás configurar ajustes generales del sistema.',
    },
    role: {
      client: 'Cliente',
      admin: 'Negocio / Estudio',
      reseller: 'Distribuidor',
      superadmin: 'SuperAdmin',
      // Mantener para compatibilidad con datos antiguos
      photographer: 'Negocio / Estudio',
    },
    errors: {
      load: 'Error al cargar datos',
      save: 'Error al guardar cambios',
      unauthorized: 'No tienes permisos para realizar esta acción',
    },
  },

  // =====================================================
  // BLOQUE 10: MARKETING / LANDING
  // =====================================================
  marketing: {
    nav: {
      how: 'Cómo funciona',
      benefits: 'Beneficios',
      pricing: 'Precios',
      faq: 'Preguntas',
      login: 'Iniciar sesión',
      signup: 'Crear cuenta',
    },
    hero: {
      title: 'Entrega tus fotos y videos como una experiencia premium',
      subtitle: 'Página pública personalizada, descargas organizadas, branding profesional y entrega por USB. Todo en un solo lugar, sin complicaciones.',
      ctaPrimary: 'Crear cuenta gratis',
      ctaSecondary: 'Ver cómo funciona',
      feature1: 'Sin instalación',
      feature2: 'Branding personalizado',
      feature3: 'Entrega profesional',
      cardTitle: 'Entrega Completa',
      cardSubtitle: 'En minutos, no en horas',
    },
    how: {
      title: '¿Cómo funciona?',
      subtitle: 'Cinco pasos simples para entregar tus proyectos de forma profesional',
      step1Title: 'Crea tu proyecto',
      step1Desc: 'Registra un nuevo proyecto con el nombre del evento, fecha y detalles básicos. Todo organizado desde el inicio.',
      step2Title: 'Sube la portada y archivos',
      step2Desc: 'Agrega una portada atractiva y sube tus archivos: APK de galería, archivos ZIP, plantillas o cualquier recurso digital.',
      step3Title: 'Personaliza el branding',
      step3Desc: 'Configura el nombre de tu estudio, logo, colores corporativos y mensaje personalizado para tus clientes.',
      step4Title: 'Comparte el link público',
      step4Desc: 'Genera un link único y seguro que tus clientes pueden abrir desde cualquier dispositivo sin necesidad de registro.',
      step5Title: 'Entrega videos por USB',
      step5Desc: 'Configura la información del USB con videos en alta calidad. Tus clientes verán todos los detalles en la página pública.',
    },
    benefits: {
      title: 'Beneficios para fotógrafos profesionales',
      subtitle: 'Todo lo que necesitas para entregar tus proyectos de forma moderna y profesional',
      benefit1Title: 'Acceso desde cualquier dispositivo',
      benefit1Desc: 'Tus clientes pueden ver y descargar desde móvil, tablet o computadora. Sin apps, sin complicaciones.',
      benefit2Title: 'Branding 100% personalizado',
      benefit2Desc: 'Logo, colores y mensajes personalizados. Cada entrega refleja la identidad de tu estudio.',
      benefit3Title: 'Descargas organizadas',
      benefit3Desc: 'APK de galería, archivos ZIP, plantillas y más. Todo categorizado y listo para descargar.',
      benefit4Title: 'Entrega física por USB',
      benefit4Desc: 'Configura los detalles del USB con videos en alta calidad. Tus clientes sabrán exactamente qué recibirán.',
      benefit5Title: 'Seguro y privado',
      benefit5Desc: 'Cada proyecto tiene un código único. Solo quienes tengan el link pueden acceder al contenido.',
      benefit6Title: 'Ahorra tiempo',
      benefit6Desc: 'Olvídate de enviar archivos por email o servicios externos. Todo en un solo lugar, siempre disponible.',
      cta: 'Comenzar ahora',
    },
    pricing: {
      title: 'Planes para cada tipo de fotógrafo',
      subtitle: 'Elige el plan que mejor se adapte a tu volumen de trabajo',
      period: '/ mes',
      popular: 'Más Popular',
      note: 'Todos los planes incluyen soporte técnico y actualizaciones gratuitas',
      plan1Name: 'Básico',
      plan1Price: 'Gratis',
      plan1Desc: 'Perfecto para comenzar y probar la plataforma',
      plan1Feature1: 'Hasta 5 proyectos activos',
      plan1Feature2: 'Branding personalizado',
      plan1Feature3: 'Descargas ilimitadas',
      plan1Feature4: 'Soporte por email',
      plan1Cta: 'Comenzar gratis',
      plan2Name: 'Profesional',
      plan2Price: '$19',
      plan2Desc: 'Para fotógrafos con volumen medio de trabajo',
      plan2Feature1: 'Proyectos ilimitados',
      plan2Feature2: 'Branding avanzado',
      plan2Feature3: 'Almacenamiento 50GB',
      plan2Feature4: 'Links externos personalizados',
      plan2Feature5: 'Soporte prioritario',
      plan2Cta: 'Comenzar prueba',
      plan3Name: 'Estudio',
      plan3Price: '$49',
      plan3Desc: 'Para estudios con alto volumen de entregas',
      plan3Feature1: 'Todo de Profesional',
      plan3Feature2: 'Almacenamiento 200GB',
      plan3Feature3: 'Múltiples usuarios',
      plan3Feature4: 'Dominio personalizado',
      plan3Feature5: 'Estadísticas avanzadas',
      plan3Feature6: 'Soporte dedicado 24/7',
      plan3Cta: 'Contactar ventas',
    },
    faq: {
      title: 'Preguntas frecuentes',
      subtitle: 'Respuestas a las dudas más comunes sobre EasyDigitalDVD',
      q1: '¿Los videos se alojan en la plataforma?',
      a1: 'No, los videos en alta calidad se entregan físicamente por USB. En la plataforma puedes configurar la información del USB para que tus clientes sepan qué recibirán. Esto mantiene la calidad máxima y reduce costos de almacenamiento.',
      q2: '¿Puedo personalizar el branding de cada proyecto?',
      a2: 'Sí, completamente. Puedes configurar tu logo, colores corporativos, nombre del estudio y mensaje personalizado. Cada página pública reflejará la identidad de tu marca.',
      q3: '¿Qué tipo de archivos puedo subir para descarga?',
      a3: 'Puedes subir APK de galerías fotográficas, archivos ZIP con fotos, plantillas editables, imágenes individuales y cualquier otro archivo digital. Todo se organiza automáticamente por categorías.',
      q4: '¿Mis clientes necesitan crear una cuenta para ver sus fotos?',
      a4: 'No, tus clientes solo necesitan el link único del proyecto. Pueden ver y descargar todo desde cualquier navegador sin registrarse ni instalar nada.',
      q5: '¿Puedo agregar links externos como Vimeo o Google Drive?',
      a5: 'Sí, puedes agregar links externos a servicios como Vimeo, Google Drive, YouTube u otros. Estos aparecerán organizados en la página pública del proyecto.',
      q6: '¿Hay límite de descargas por proyecto?',
      a6: 'No, las descargas son ilimitadas en todos los planes. Tus clientes pueden descargar los archivos tantas veces como necesiten.',
      contactTitle: '¿Tienes más preguntas?',
      contactDesc: 'Nuestro equipo está listo para ayudarte',
      contactCta: 'Contactar soporte',
    },
    footer: {
      description: 'La plataforma profesional para fotógrafos que quieren entregar sus proyectos de forma moderna y sin complicaciones.',
      product: 'Producto',
      support: 'Soporte',
      contact: 'Contacto',
      rights: '© 2024 EasyDigitalDVD. Todos los derechos reservados.',
      poweredBy: 'Powered by Readdy',
    },
  },

  // =====================================================
  // BLOQUE QR: Códigos QR por proyecto
  // =====================================================
  qr: {
    title: 'Código QR del proyecto',
    scan: 'Escanea este código para acceder al proyecto',
    copy: 'Copiar enlace',
    download: 'Descargar QR (PNG)',
    copied: '¡Enlace copiado!',
    publicLink: 'Enlace público',
  },

  // =====================================================
  // BLOQUE ADM-2: KIT DE ENTREGA
  // =====================================================
  deliveryKit: {
    title: 'Kit de Entrega',
    loading: 'Cargando kit de entrega…',
    notFound: 'Proyecto no encontrado',
    notFoundDesc: 'No se pudo cargar la información del proyecto',
    backToProjects: 'Volver a proyectos',
    backToProject: 'Volver al proyecto',
    print: 'Imprimir',
    saved: 'Guardado correctamente',
    headerTitle: 'Kit de Entrega - USB Interactivo',
    headerSubtitle: 'Menú digital profesional',
    project: 'Proyecto',
    client: 'Cliente',
    eventDate: 'Fecha del evento',
    noName: 'Sin nombre',
    quickAccess: 'Acceso Rápido',
    scanWithPhone: 'Escanea con tu celular',
    howToUse: 'Cómo usar tu USB interactivo',
    step1Title: 'Conecta el USB',
    step1Desc: 'Inserta el USB en tu TV, computadora o cualquier dispositivo compatible.',
    step2Title: 'Navega por el contenido',
    step2Desc: 'Abre el archivo principal del menú interactivo (normalmente etiquetado como "INICIO").',
    step3Title: 'Acceso en línea',
    step3Desc: 'Escanea el código QR con tu celular para ver el contenido desde cualquier lugar.',
    step4Title: 'Comparte con familiares',
    step4Desc: 'Envía el enlace a tus seres queridos para que también puedan disfrutar del contenido.',
    photographerNote: 'Nota del fotógrafo',
    editNote: 'Editar nota',
    saveNote: 'Guardar nota',
    notePlaceholder: 'Escribe un mensaje personalizado para tu cliente (ej: "Gracias por confiar en nosotros", "Incluye highlights y sesión completa", etc.)',
    noNote: 'No hay nota personalizada. Haz clic en "Editar nota" para agregar un mensaje.',
    needHelp: '¿Necesitas ayuda?',
    helpDesc: 'Si tienes alguna dificultad para acceder al contenido o necesitas asistencia, no dudes en contactar a tu fotógrafo. Estamos aquí para ayudarte a disfrutar de tus recuerdos de la mejor manera posible.',
    createdWith: 'Creado con',
    by: 'por',
    tagline: 'Menús digitales profesionales para fotógrafos',
  },

  // =====================================================
  // BLOQUE ONLINE-1: VER EN LÍNEA
  // =====================================================
  online: {
    title: 'Ver en línea',
    enabled: 'Habilitar visualización en línea',
    enabledDesc: 'Permite que tus clientes vean el contenido desde cualquier parte del mundo',
    duration: 'Duración del acceso',
    durationDays: 'días',
    benefit: 'Ideal para compartir con familiares y amigos desde cualquier parte del mundo.',
    status: {
      none: 'No configurado',
      uploading: 'Subiendo...',
      pending: 'Procesando',
      active: 'Activo',
      expired: 'Expirado',
      error: 'Error',
    },
    statusDesc: {
      none: 'Habilita la opción para comenzar',
      uploading: 'El contenido se está subiendo al servidor',
      pending: 'Procesando (puede tomar hasta 24h)',
      active: 'Disponible hasta',
      expired: 'El acceso ha expirado',
      error: 'Hubo un problema',
    },
    expiresAt: 'Activo hasta',
    reactivate: 'Reactivar',
    viewOnline: 'Ver en línea',
    uploadVideo: 'Subir video',
  },

  // =====================================================
  // BLOQUE ONLINE-2: SUBIDA DE VIDEO
  // =====================================================
  upload: {
    title: 'Subir Video para Ver en Línea',
    selectFile: 'Selecciona tu archivo MP4',
    requirements: 'Formato MP4, máximo 3GB',
    clickToChange: 'Clic para cambiar archivo',
    startUpload: 'Iniciar subida',
    uploading: 'Subiendo tu video...',
    doNotClose: 'No cierres esta ventana mientras se sube el archivo',
    preparingMessage: 'Estamos preparando tu película para compartirla en línea.',
    activationTime: 'La activación puede tardar hasta 24 horas.',
    successTitle: '¡Video subido correctamente!',
    successMessage: 'Tu video está siendo procesado. Te notificaremos cuando esté listo.',
    errorTitle: 'Error al subir',
    retry: 'Reintentar',
    errors: {
      invalidType: 'Solo se permiten archivos MP4',
      tooLarge: 'El archivo excede el límite de 3GB',
      unknown: 'Error desconocido al subir el archivo',
      network: 'Error de conexión. Verifica tu internet.',
      timeout: 'La conexión tardó demasiado. Intenta de nuevo.',
    },
  },

  onboarding: {
    pendingTitle: 'Cuenta en Revisión',
    pendingDescription: 'Tu cuenta está siendo revisada por nuestro equipo. Te notificaremos por correo electrónico cuando esté aprobada.',
    registeredEmail: 'Correo registrado',
    pendingHelp: '¿Necesitas ayuda? Contacta con soporte en soporte@easydigitaldvd.com',
    backToHome: 'Volver al inicio',
  },
  
  account: {
    suspendedTitle: 'Cuenta Suspendida',
    suspendedDescription: 'Tu cuenta ha sido suspendida temporalmente. Por favor, contacta con el administrador para más información.',
    accountEmail: 'Correo de la cuenta',
    suspendedHelp: 'Para resolver este problema, contacta con soporte en soporte@easydigitaldvd.com',
    backToHome: 'Volver al inicio',
  },

  // =====================================================
  // BLOQUE PAY-1: PAGOS MANUALES (FOTÓGRAFO)
  // =====================================================
  billing: {
    title: 'Cobros / Renovaciones',
    subtitle: 'Registra tus pagos y comprobantes para renovaciones online',
    navTitle: 'Cobros',
    registerPayment: 'Registrar pago',
    noPayments: 'No hay pagos registrados',
    noPaymentsDesc: 'Registra tu primer pago para llevar un historial de tus renovaciones.',
    registerFirst: 'Registrar primer pago',
    infoTitle: 'Sistema de pagos manuales',
    infoDesc: 'Registra aquí tus pagos realizados por fuera de la plataforma. Sube el comprobante y nuestro equipo verificará el pago para activar o renovar tu servicio.',
    paymentType: 'Tipo de pago',
    amount: 'Monto',
    paymentMethod: 'Método de pago',
    notes: 'Notas',
    notesPlaceholder: 'Ej: Pago por renovación de proyecto XV años María...',
    receipt: 'Comprobante',
    uploadReceipt: 'Clic para subir comprobante',
    receiptFormats: 'JPG, PNG, PDF (máx. 10MB)',
    viewReceipt: 'Ver comprobante',
    saving: 'Guardando...',
    register: 'Registrar pago',
    errorCreating: 'Error al registrar el pago. Intenta de nuevo.',
    invalidFileType: 'Tipo de archivo no válido. Solo JPG, PNG o PDF.',
    fileTooLarge: 'El archivo es muy grande. Máximo 10MB.',
    colDate: 'Fecha',
    colType: 'Tipo',
    colAmount: 'Monto',
    colMethod: 'Método',
    colStatus: 'Estado',
    colReceipt: 'Comprobante',
  },

  // =====================================================
  // BLOQUE PAY-1: PAGOS MANUALES (SUPERADMIN)
  // =====================================================
  saPayments: {
    title: 'Pagos de Fotógrafos',
    description: 'Revisa y aprueba los pagos registrados por los fotógrafos',
    searchPlaceholder: 'Buscar por fotógrafo o email...',
    filterAll: 'Todos',
    noPayments: 'No hay pagos registrados',
    pendingReview: 'pendientes de revisión',
    colDate: 'Fecha',
    colPhotographer: 'Fotógrafo',
    colType: 'Tipo',
    colAmount: 'Monto',
    colMethod: 'Método',
    colStatus: 'Estado',
    viewDetails: 'Ver detalles',
    paymentDetails: 'Detalles del pago',
    approve: 'Aprobar pago',
    reject: 'Rechazar',
  },

  // =====================================================
  // BLOQUE ONLINE-3 + ONLINE-4: SUPERADMIN STREAMING + EMAILS
  // =====================================================
  saOnline: {
    title: 'Streaming Online',
    description: 'Gestiona los proyectos con visualización en línea',
    searchPlaceholder: 'Buscar por proyecto o fotógrafo...',
    filterAll: 'Todos',
    filterPending: 'Pendientes',
    filterActive: 'Activos',
    filterExpired: 'Expirados',
    noProjects: 'No hay proyectos con streaming habilitado',
    colProject: 'Proyecto',
    colOwner: 'Fotógrafo',
    colStatus: 'Estado',
    colDuration: 'Duración',
    colExpires: 'Expira',
    statusPending: 'Pendiente',
    statusActive: 'Activo',
    statusExpired: 'Expirado',
    statusError: 'Error',
    activate: 'Activar',
    activateNow: 'Activar ahora',
    activateTitle: 'Activar Streaming',
    activateSuccess: '¡Streaming activado correctamente!',
    deactivate: 'Desactivar',
    confirmDeactivate: '¿Estás seguro de desactivar el streaming de este proyecto?',
    reactivate: 'Reactivar',
    reactivateTitle: 'Reactivar Streaming',
    view: 'Ver',
    currentStatus: 'Estado actual',
    embedUrl: 'URL/Embed de Muse',
    embedUrlPlaceholder: 'Pega aquí el código embed de Muse o la URL del video...',
    embedUrlHint: 'Puedes pegar el código iframe completo o solo la URL del video',
    // BLOQUE ONLINE-4: Emails
    emailsSending: 'Enviando notificaciones por correo...',
    emailsSent: '¡Correos enviados al fotógrafo y cliente!',
    emailsError: 'No se pudieron enviar algunos correos (la activación fue exitosa)',
  },

  // =====================================================
  // BLOQUE ONLINE-3: PÁGINA PÚBLICA STREAMING
  // =====================================================
  publicOnline: {
    title: 'Ver en Línea',
    subtitle: 'Disfruta tu contenido desde cualquier dispositivo',
    availableUntil: 'Disponible hasta',
    expiredTitle: 'Acceso no disponible',
    expiredMessage: 'El acceso en línea de este evento no está disponible por el momento. Para reactivarlo, contacta al estudio.',
    pendingTitle: 'Contenido en preparación',
    pendingMessage: 'Tu contenido está siendo procesado. Estará disponible pronto.',
  },

  // =====================================================
  // BLOQUE PAY-2: CONFIGURACIÓN DE PAGOS (FOTÓGRAFO)
  // =====================================================
  settings: {
    title: 'Configuración',
    subtitle: 'Administra tu cuenta y preferencias de pago',
    navTitle: 'Configuración',
    paymentsTitle: 'Pagos (Opcional)',
    paymentsSubtitle: 'Configura tus credenciales para recibir pagos en línea',
    comingSoonTitle: 'Próximamente',
    comingSoonDesc: 'Los pagos en línea estarán disponibles pronto. Por ahora, puedes guardar tus credenciales para cuando la funcionalidad esté activa.',
    enableOnlinePayments: 'Habilitar pagos en línea',
    enableOnlinePaymentsDesc: 'Permite que tus clientes paguen directamente desde la página pública',
    optional: 'Opcional',
    paypalEmail: 'Email de PayPal',
    paypalEmailHint: 'El email asociado a tu cuenta de PayPal Business',
    paypalClientId: 'Client ID de PayPal',
    paypalClientIdHint: 'Obtén tu Client ID desde el panel de desarrolladores de PayPal',
    stripePublicKey: 'Clave pública de Stripe',
    stripePublicKeyHint: 'Comienza con pk_live_ o pk_test_',
    stripeSecretKey: 'Clave secreta de Stripe',
    stripeSecretKeyHint: 'Comienza con sk_live_ o sk_test_ (se almacena de forma segura)',
    securityNote: 'Seguridad de tus credenciales',
    securityNoteDesc: 'Tus claves secretas se almacenan de forma segura y nunca se muestran en el frontend. Solo se utilizarán cuando los pagos en línea estén habilitados.',
    saved: 'Guardado correctamente',
    saving: 'Guardando...',
    save: 'Guardar cambios',
  },

  client: {
    myProjects: 'Mis Proyectos',
    noProjects: 'No tienes proyectos',
    openMenu: 'Abrir Menú',
    projectsDescription: 'Accede a tus proyectos de DVD digital',
  },

  // =====================================================
  // BLOQUE FACTURACIÓN: INVOICES
  // =====================================================
  saInvoices: {
    title: 'Facturación',
    description: 'Gestiona las facturas mensuales de los fotógrafos',
    generateMonthly: 'Corte del mes',
    generating: 'Generando...',
    confirmGenerate: '¿Generar facturas para el periodo',
    generatedSuccess: 'Facturas generadas exitosamente:',
    generatedWithErrors: 'Facturas generadas con algunos errores',
    success: 'Exitosas',
    errors: 'Errores',
    invoices: 'facturas',
    generateError: 'Error al generar facturas',
    
    // Stats
    totalInvoices: 'Total Facturas',
    pendingAmount: 'Monto Pendiente',
    paidAmount: 'Monto Pagado',
    totalAmount: 'Monto Total',
    
    // Filters
    searchPlaceholder: 'Buscar por número de factura, fotógrafo o email...',
    filterAll: 'Todas',
    
    // Table columns
    colInvoiceNumber: 'Número',
    colPeriod: 'Periodo',
    colPhotographer: 'Fotógrafo',
    colTotal: 'Total',
    colStatus: 'Estado',
    colCreated: 'Creada',
    
    // Status
    status_draft: 'Borrador',
    status_sent: 'Enviada',
    status_paid: 'Pagada',
    status_void: 'Anulada',
    
    // Actions
    viewDetails: 'Ver detalles',
    markAsSent: 'Marcar como enviada',
    markAsPaid: 'Marcar como pagada',
    markAsVoid: 'Anular',
    
    // Details
    period: 'Periodo',
    items: 'Partidas',
    notes: 'Notas',
    createdAt: 'Fecha de creación',
    sentAt: 'Fecha de envío',
    paidAt: 'Fecha de pago',
    
    // Empty states
    noInvoices: 'No hay facturas registradas',
  },
};
